import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from 'rxjs';
import { Route } from '@angular/compiler/src/core';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  navLink: any;
  constructor(public navCtrl: NavController) {}


  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.navLink = route["_routerState"]["url"];
      return true;
    // if(this.navLink == sessionStorage.CurrentPage)
    //   return true;
    // else{
    //   if (localStorage.tourstatus != undefined && localStorage.tourstatus == "Visited") {
    //     if (localStorage.logined != null && localStorage.logined != undefined && !(localStorage.freezetime)) {
    //       sessionStorage.CurrentPage = "/loginva"
    //       this.navCtrl.navigateRoot("/loginva")
    //     }else{
    //       if (localStorage.role == "" || localStorage.role == undefined || localStorage.role != "new") {
    //         if (localStorage.freezetime) {
    //           sessionStorage.CurrentPage = "/freezescreen"
    //           this.navCtrl.navigateRoot("/freezescreen")
    //         }else {
    //           sessionStorage.CurrentPage = "/preRegister"
    //           this.navCtrl.navigateRoot("/preRegister")
    //         }
    //       }else {
    //         sessionStorage.CurrentPage = "/va/chat"
    //         this.navCtrl.navigateRoot("/va/chat");
    //       }
    //     }
    //   }else{
    //     sessionStorage.CurrentPage = "/language"
    //     this.navCtrl.navigateRoot("/language");
    //   }
    //   return true;
    // }
      
  }
}
